import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["viewBox"]
const _hoisted_2 = ["d", "opacity"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.svg)
    ? (_openBlock(), _createElementBlock("svg", {
        key: 0,
        class: _normalizeClass(["rank-ic", _ctx.extraClass]),
        viewBox: _ctx.svg.viewBox,
        role: "img",
        "aria-hidden": "true",
        focusable: "false"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.svg.paths, (p, i) => {
          return (_openBlock(), _createElementBlock("path", {
            key: i,
            d: p.d,
            opacity: p.opacity,
            fill: "currentColor"
          }, null, 8, _hoisted_2))
        }), 128))
      ], 10, _hoisted_1))
    : (_openBlock(), _createElementBlock("i", {
        key: 1,
        class: _normalizeClass(_ctx.fallbackClass)
      }, null, 2))
}